import { createFeatureSelector, createSelector } from '@ngrx/store'
import * as R from 'ramda'
import { State } from './rule.state'
import { selectAll, selectEntities } from './rule.reducer'
import { selectAllInvoiceTemplateViews } from '../templates/template.selectors'
import { InvoiceRule, InvoiceRuleView } from './rule.model'
import { InvoiceTemplateView } from '../templates/template.model'

export const invoiceRuleState = createFeatureSelector<State>('invoice-rule-lib')

export const selectAllInvoiceRules = createSelector(invoiceRuleState, selectAll)

export const selectInvoiceRulesEntities = createSelector(invoiceRuleState, selectEntities)

export const selectInvoiceRulesLoaded = createSelector(invoiceRuleState, (state) => state.isLoaded)

export const isInvoiceRulesUpdating = createSelector(invoiceRuleState, (state) => state.isUpdating)

export const selectInvoiceRule = createSelector(selectInvoiceRulesEntities, (entities, props) => {
  return entities[props.id]
})

export const selectInvoiceRuleConditions = createSelector(selectInvoiceRulesEntities, (entities, props) => {
  const rule = entities[props.id]
  if (rule) {
    return rule.conditions
  } else {
    return []
  }
})

export const selectAllInvoiceRulesViews = createSelector(
  selectAllInvoiceRules,
  selectAllInvoiceTemplateViews,
  (rules, templates) => {
    return R.map((r: InvoiceRule) => {
      let ruleView = InvoiceRuleView.deserialize(r)
      ruleView.templateView = R.find((t: InvoiceTemplateView) => t.pkey === r.template, templates)
      return ruleView
    }, rules)
  }
)

export const selectInvoiceTemplateRules = createSelector(selectAllInvoiceRulesViews, (rules, props) => {
  return R.filter((rule: InvoiceRuleView) => rule.template === props.id, rules)
})

export const selectInvoiceRulesTags = createSelector(selectAllInvoiceRules, (rules) => {
  return R.pipe(
    R.map((r: InvoiceRule) => R.pathOr([], ['attributes', 'tags'], r)),
    R.flatten,
    R.reject(R.isNil),
    R.reject(R.isEmpty),
    R.uniq,
    R.sort((a, b) => a.toString().localeCompare(b, undefined, { numeric: true, sensitivity: 'base' }))
  )(rules)
})
